export * from './legals.og';
export * from './legals.slice';
